import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Box,
  TextField,
  IconButton,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";

const ChatInput = ({ onInputClick }) => {
  const intl = useIntl();
  const [message, setMessage] = useState("");
  const [isDeepResearchActive, setIsDeepResearchActive] = useState(false);

  const handleDeepResearchToggle = () => {
    setIsDeepResearchActive(!isDeepResearchActive);
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 800,
        mx: "auto",
        p: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "50px 0",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          fontWeight: 200,
        }}
      >
        <FormattedMessage id="app.chat.title" />
      </Typography>

      <Paper
        elevation={0}
        sx={{
          width: "100%",
          bgcolor: "#ffffffff",
          border: "1px solid #000",
          borderRadius: 3,
          p: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <TextField
          fullWidth
          variant="standard"
          placeholder={intl.formatMessage({
            id: "app.chat.input.placeholder",
          })}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onFocus={onInputClick}
          multiline
          rows={2}
          sx={{
            mx: 2,
            "& .MuiInput-root": {
              color: "#000",
              "&:before": { borderBottom: "none" },
              "&:after": { borderBottom: "none" },
              "&:hover:not(.Mui-disabled):before": { borderBottom: "none" },
            },
            "& .MuiInput-input": {
              "&::placeholder": {
                color: "#666666",
                opacity: 1,
              },
            },
          }}
        />

        <IconButton
          sx={{
            color: "#000",
            "&:hover": { bgcolor: "#404040" },
          }}
        >
          <ArrowUpwardIcon />
        </IconButton>
      </Paper>
      <Button
        variant={isDeepResearchActive ? "contained" : "outlined"}
        onClick={handleDeepResearchToggle}
        sx={{
          mt: 2,
          borderColor: "#000",
          color: isDeepResearchActive ? "#fff" : "#000",
          bgcolor: isDeepResearchActive ? "#000" : "transparent",
          borderRadius: 2,
          textTransform: "none",
          fontSize: "14px",
          alignSelf: "flex-start",
          "&:hover": {
            borderColor: "#000",
            bgcolor: isDeepResearchActive ? "#333" : "#f5f5f5",
          },
        }}
      >
        <TravelExploreIcon />
        Deep Research
      </Button>
    </Box>
  );
};

export default ChatInput;
